import React from 'react';
import { Outlet, useOutletContext } from 'react-router-dom';
import { Alert } from '../components/common';
import { MapPinIcon } from '@heroicons/react/24/outline';

interface MapLayoutProps {}

const MapLayout: React.FC<MapLayoutProps> = () => {
  const contextFromAppLayout = useOutletContext<any>();

  const { locateError, handleLocateErrorClear } = contextFromAppLayout || {};

  return (
    <div className="flex h-full min-h-0 flex-col overflow-hidden">
      <div className="container mx-auto shrink-0">
        {locateError && (
          <Alert
            variant="error"
            icon={<MapPinIcon className="w-5 h-5" />}
            className="mb-4"
            onClose={handleLocateErrorClear}
          >
            {locateError}
          </Alert>
        )}
      </div>
      <div className="flex-1 min-h-0 overflow-hidden">
        <Outlet context={contextFromAppLayout} />
      </div>
    </div>
  );
};

export default MapLayout;
